import React, { useEffect, useRef } from 'react';
import { galleryImages } from '../data/mockData';

const GallerySection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="gallery" className="py-20 md:py-28 bg-white" ref={sectionRef}>
      {/* Section Header */}
      <div className="text-center mb-16 md:mb-20 animate-on-scroll animate-fade-up">
        <h4 className="font-script text-3xl md:text-4xl text-gray-400 mb-3">Sweet Memories</h4>
        <h2 className="font-heading text-3xl md:text-[40px] text-gray-800 mb-6">Our Captured Moment</h2>
        <div className="w-20 h-[1.5px] bg-olive/40 mx-auto"></div>
      </div>

      {/* Gallery Grid */}
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {galleryImages.map((img, index) => (
            <div
              key={index}
              className="relative group animate-on-scroll animate-scale-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative overflow-hidden">
                <img
                  src={img}
                  alt={`Gallery ${index + 1}`}
                  className="w-full h-[300px] md:h-[340px] object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-4 border border-white/40 z-20 pointer-events-none transition-all duration-500 group-hover:inset-6"></div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-all duration-500 z-10"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
